import { AxiosInstance } from 'axios'
import { useQuery } from 'react-query'
import { useAxiosContext } from '@dc-shared-web/providers/AxiosProvider'

import {
  Annotation,
  AnnotationResponse,
} from '@dc-shared-web/hooks/api/annotations/types'

export type GetAnnotationsResponse = {
  // key: p:1, p:2, p:3, etc.
  data: Record<string, AnnotationResponse[]>
  highlights: Record<string, AnnotationResponse[]>
}

const formatAnnotationData = (
  data: Record<string, AnnotationResponse[]>
): Annotation[] => {
  const keys = Object.keys(data)
  const annotationMap = new Map<string, Annotation>()

  for (const key of keys) {
    for (const annotation of data[key]) {
      annotationMap.set(annotation.refId, {
        ...annotation,
        metadata: JSON.parse(annotation.metadata),
      })
    }
  }

  return Array.from(annotationMap.values())
}

const fetchAnnotations = async (
  apiClient: AxiosInstance,
  crunchUUID: string
): Promise<{
  data: Annotation[]
  highlights: Record<string, AnnotationResponse[]>
}> => {
  const { data } = await apiClient.get<GetAnnotationsResponse>(
    `/ajax/crunches/annotations/${crunchUUID}/false`
  )

  return {
    data: formatAnnotationData(data.data),
    highlights: data.highlights,
  }
}

export const useGetAnnotations = (crunchUUID: string) => {
  const apiClient = useAxiosContext()

  return useQuery({
    queryKey: ['annotations', crunchUUID],
    queryFn: () => fetchAnnotations(apiClient, crunchUUID),
  })
}
